/** Word-wrap at spaces; preserve explicit line breaks. */
export function splitTextLines(text) {
  const s = String(text ?? '');
  if (!s) return [''];
  return s.split(/\r?\n/).map((line) => line || '');
}

function breakWordToWidth(word, maxWidth, measureLineWidth) {
  const parts = [];
  let chunk = '';
  for (const ch of word) {
    const candidate = chunk + ch;
    if (measureLineWidth(candidate) <= maxWidth + 0.5 || !chunk) {
      chunk = candidate;
    } else {
      parts.push(chunk);
      chunk = ch;
    }
  }
  if (chunk) parts.push(chunk);
  return parts.length ? parts : [word];
}

export function wrapParagraph(paragraph, maxWidth, measureLineWidth) {
  const words = String(paragraph || '').split(/\s+/).filter(Boolean);
  if (!words.length) return [''];
  if (maxWidth <= 0) return [words.join(' ')];

  const lines = [];
  let current = '';
  for (const word of words) {
    const candidate = current ? `${current} ${word}` : word;
    const w = measureLineWidth(candidate);
    if (w <= maxWidth + 0.5 || !current) {
      if (!current && measureLineWidth(word) > maxWidth + 0.5) {
        const parts = breakWordToWidth(word, maxWidth, measureLineWidth);
        for (let i = 0; i < parts.length - 1; i++) lines.push(parts[i]);
        current = parts[parts.length - 1];
      } else {
        current = candidate;
      }
    } else {
      lines.push(current);
      if (measureLineWidth(word) > maxWidth + 0.5) {
        const parts = breakWordToWidth(word, maxWidth, measureLineWidth);
        for (let i = 0; i < parts.length - 1; i++) lines.push(parts[i]);
        current = parts[parts.length - 1];
      } else {
        current = word;
      }
    }
  }
  if (current) lines.push(current);
  return lines.length ? lines : [''];
}

export function wrapTextToLines(text, maxWidth, measureLineWidth) {
  const paragraphs = splitTextLines(text);
  const out = [];
  for (const p of paragraphs) {
    if (!p.trim()) {
      out.push('');
      continue;
    }
    out.push(...wrapParagraph(p, maxWidth, measureLineWidth));
  }
  return out.length ? out : [''];
}
